const config = {
  url: 'https://688g4nadsb.execute-api.us-east-1.amazonaws.com/search/'
}
export default config